import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import DialogPanel from '@/components/common/DialogPanel';
import type {AppError, BusinessErrorCodes} from '@/domain/interfaces/ErrorService';

//TYPES
type Props = {
  error: AppError;
  onClose: () => void;
};

const ErrorsDialog: FC<Props> = ({error, onClose}) => {
  const {t} = useTranslation();

  const businessErrorCodesLabels: Record<BusinessErrorCodes, string> = {
    GPKG_INVALID_CRS: t('businessErrorCodes.GPKG_INVALID_CRS'),
    GPKG_INVALID_DIMENSION: t('businessErrorCodes.GPKG_INVALID_DIMENSION'),
    GPKG_INVALID_GEOMETRY: t('businessErrorCodes.GPKG_INVALID_GEOMETRY'),
    GPKG_UNREADABLE: t('businessErrorCodes.GPKG_UNREADABLE'),
    LAS_LAZ_INVALID_EXTENSION: t('businessErrorCodes.LAS_LAZ_INVALID_EXTENSION'),
    LAS_LAZ_INVALID_CONTENT: t('businessErrorCodes.LAS_LAZ_INVALID_CONTENT'),
    LAS_LAZ_INVALID_VERSION: t('businessErrorCodes.LAS_LAZ_INVALID_VERSION'),
    LAS_LAZ_INVALID_CRS: t('businessErrorCodes.LAS_LAZ_INVALID_CRS'),
  };

  const message = error.businessErrorCode ? businessErrorCodesLabels[error.businessErrorCode] : error.message;

  return (
    <DialogPanel isOpen={true} label={t('errors')} onClose={onClose}>
      <Stack direction="column" sx={{maxWidth: '500px', p: 1}}>
        <Typography key={error.message} sx={{my: 2}}>
          {message}
        </Typography>

        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <Button variant="contained" onClick={onClose}>
            {t('close')}
          </Button>
        </Stack>
      </Stack>
    </DialogPanel>
  );
};
export default ErrorsDialog;
